module.exports = __webpack_public_path__ + "0e8bbb69061cff0e4693f1ac8374748a.png";